export default __webpack_public_path__ + "static/media/apartmentIcon.4f04f77d.svg";